export default __webpack_public_path__ + "static/media/mypic.c4cd672c.jpeg";